import angular from 'angular';

angular.module('cfn').config(appConfig);

appConfig.$inject = [
  '$controllerProvider',
  '$routeProvider',
  '$compileProvider',
  '$filterProvider',
  '$provide',
  'DemoAccountServiceProvider',
  '$httpProvider',
];
function appConfig(
  $controllerProvider,
  $routeProvider,
  $compileProvider,
  $filterProvider,
  $provide,
  DemoAccountServiceProvider,
  $httpProvider
) {
  let deprecationWarning = true;

  app.register = {
    controller: function(name, constructor) {
      deprecationWarning &&
        console.warn(
          'using deprecated app.register.controller method transition to angular.Module',
          name
        );
      $controllerProvider.register(name, constructor);
    },
    directive: function(name, directiveFactory) {
      deprecationWarning &&
        console.warn(
          'using deprecated app.register.directive method transition to angular.Module',
          name
        );

      $compileProvider.directive(name, directiveFactory);
    },
    filter: function(name, factory) {
      deprecationWarning &&
        console.warn(
          'using deprecated app.register.filter method transition to angular.Module',
          name
        );
      $filterProvider.register(name, factory);
    },
    factory: function(name, $getFn) {
      deprecationWarning &&
        console.warn(
          'using deprecated app.register.factory method transition to angular.Module',
          name
        );
      $provide.factory(name, $getFn);
    },
    service: function(name, constructor) {
      deprecationWarning &&
        console.warn(
          'using deprecated app.register.service method transition to angular.Module',
          name
        );
      $provide.service(name, constructor);
    },
    value: function(name, value) {
      deprecationWarning &&
        console.warn(
          'using deprecated app.register.value method transition to angular.Module',
          name
        );
      $provide.value(name, value);
    }
  };

  init();

  function init() {
    DemoAccountServiceProvider.setIsDemoAccount(
      app.credentials.userProperties['demo-account'] === 'true'
    );

    // use $injector instead of direct DI, to prevent circular dependency errors
    $provide.decorator('$exceptionHandler', exceptionHandlerDecorator);


    $provide.factory('myHttpInterceptor', httpInterceptorfunction);

    $httpProvider.interceptors.push('myHttpInterceptor');

  }





  exceptionHandlerDecorator.$inject = ['$delegate', '$injector'];
  function exceptionHandlerDecorator($delegate, $injector) {
    return function(exception, cause) {
      app.finishLoading(); // Stop all "waiting"-Events
      var i18n = i18n || $injector.get('i18nFilter');

      $delegate(exception, cause);
      var message;
      if (exception && exception.message) {
        if (exception.name) {
          message = exception.name + ': ' + exception.message;
        } else {
          message = exception.message;
        }
      } else {
        message = i18n(
          'fe.admin.ticket.sendTicket.message.default',
          'unbekannter Fehler'
        );
      }

      var $location = $location || $injector.get('$location');

      $injector.get('error-message.service').reportException({
        message: message,
        cause: cause,
        context: $location.path()
      });
    };
  }


  httpInterceptorfunction.$inject = ['$q'];
  function httpInterceptorfunction($q) {
    return {

      // optional method
      // 'response': function(response) {
      //
      //   let headers = response.headers();
      //   if (headers['x-farmnet-correlationid']) {
      //     response['x-farmnet-correlationid'] = headers['x-farmnet-correlationid'];
      //     response['x-farmnet-date'] = headers['date'];
      //   }
      //
      //   // do something on success
      //   return response;
      // },

      // optional method
      'responseError': function(rejection) {

        let headers = rejection.headers();

        if (headers['x-farmnet-correlationid']) {
          rejection['x-farmnet-correlationid'] = headers['x-farmnet-correlationid'];
          rejection['x-farmnet-date'] = headers['date'];
        }

        // do something on error
        return $q.reject(rejection);
      }
    };
  }


}
